<!-- 展示区域 -->
<template>
    <div class="view">
        <div class="view-text">检查区</div>
        <div class="view-area">
            <h2 class="view-area--title">{{view.title}}</h2>
            <div style="padding-bottom: 15px">{{view.welcome}}</div>
            <question-view v-for="(question, index) in view.questionList"
                           :number="index + 1"
                           :question="question" :key="question.order"/>
        </div>
    </div>
</template>

<script>
import QuestionView from "@/components/questionView"
export default {
    name: "ViewArea",
    props: {
        view: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    components: {
        QuestionView
    }
}
</script>

<style scoped lang="less">
@import "../index";

.view-text {
    margin-left: 30px;
    font-size: 16px;
    margin-bottom: 30px;
}

.view-area {
    background-color: #fff;
    height: 824px;
    background-image: none;
    box-sizing: border-box;
    line-height: 1.5;
    resize: none;
    color: #606266;
    padding: 30px;
    font-size: 16px;
    width: 100%;
    overflow-y: auto;
    &--title {
        text-align: center;
    }
}
</style>
